import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es')
/** *
* *Generates Plays reports by country
@param plays Plays data
@param action Defines if it saves it or dislpays it
*/

const generatePDFPlaysByCountry = (plays,action) => {
    // initialize jsPDF
    const doc = new jsPDF();
  
    // define the columns we want and their titles
    const tableColumn = ["País", "Novela", "Teatro", "Ensayo de tema artístico-literario","Literatura para niños y jóvenes","Total",];
    // define an empty array of rows
    const tableRows = [];
  
    // for each play, pass all its data into an array
    plays.forEach(play => {
      const playData = [
          play.country,
          play["totalNovela"],
          play['totalTeatro'],
          play["totalEnsayo de tema artístico-literario"],
          play["totalLiteratura para niños y jóvenes"],
          play['total'],
      ];
      // push each play's info into a row
      tableRows.push(playData);
    });
  
    // startY is basically margin-top
    moment.locale('es')
    var today = moment(Date.now())
  
    const date = Date().split(" ");
    // we use a date string to generate our filename.
    const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
    // we define the name of our PDF file.
    doc.text(`Premio Casa de las Americas 2024`, 55, 15);
    doc.text(`${today.format('LL')}`, 80, 25);
    doc.text("Reporte de Obras por países", 8, 30);
    doc.autoTable(tableColumn, tableRows, { startY: 35 });
    if(action === "save"){
      doc.save(`reporte_obras_pais_${dateStr}.pdf`);
    }
    else{
      doc.setProperties({
        title: `reporte_obras_${dateStr}.pdf`
        });
        doc.output('dataurlnewwindow');
    }
};
  
export default generatePDFPlaysByCountry;